import { Component, Input, OnInit } from '@angular/core';
import { ChartDataSets } from 'chart.js';
import { Color, Label } from 'ng2-charts';

@Component({
  selector: 'app-inventory-line-chart',
  templateUrl: './inventory-line-chart.component.html',
  styleUrls: ['./inventory-line-chart.component.css']
})
export class InventoryLineChartComponent implements OnInit {

//   // @Input() public lineChartData: any[] = [];
//  public lineChartLabels: Label[] = ['a', 'b', 'c', 'd', 'e', 'a', 'b', 'c', 'd', 'e'];
//   public lineChartOptions: any = {responsive: true,
//     title: {
//       display: true,
//       text: "Tank Data"
//     },
//     tooltips: {
//       mode: "index",
//       intersect: true
//     },
//     legend: {
//       display: true,
//       position: "bottom",
//       labels: {
//         fontColor: "#3f5761"
//       }
//     },
//     annotation: {
//       events: ["click"],
//       annotations: [
//         {
//           drawTime: "beforeDatasetsDraw",
//           id: "hline",
//           type: "line",
//           mode: "horizontal",
//           scaleID: "y-axis-0",
//           value: 1,
//           borderColor: "black",
//           borderWidth: 20,
//           // label: {
//           //   backgroundColor: "red",
//           //   content: "Test Label",
//           //   enabled: true
//           // },
//           onClick: function(e) {
//             // The annotation is is bound to the `this` variable
//             console.log("Annotation", e.type, this);
//           }
//         },
//         {
//           drawTime: "beforeDatasetsDraw",
//           type: "box",
//           xScaleID: "x-axis-0",
//           yScaleID: "y-axis-0",
//           xMin: "February",
//           xMax: "April",
//           // yMin: randomScalingFactor(),
//           // yMax: randomScalingFactor(),
//           // backgroundColor: "rgba(101, 33, 171, 0.5)",
//           // borderColor: "rgb(101, 33, 171)",
//           borderWidth: 1,
//           onClick: function(e) {
//             console.log("Box", e.type, this);
//           }
//         }
//       ]
//     }};
//   public lineChartColors: Color[] = [
//     {
//       borderColor: '#0000EE',
//       backgroundColor: '#627d9433',
//     },
//     {
//       borderColor: '#0000EE',
//       backgroundColor: '#c353671c',
//     },
//     {
//       borderColor: 'gray',
//       backgroundColor: '#24ca851c',
//     },
//     {
//       borderColor: 'gray',
//       backgroundColor: '#6165639e',
//     },
//   ];

//   public lineChartData: any[] = [
//     { data: [1,4,2,6,3, 8,1,4,2,6], label: 'HS',  pointRadius: 1, pointBorderColor: "black", pointBorderWidth: 2, 
//     pointBackgroundColor:"yellow", fill: false, borderColor: 'black', backgroundColor: "green", borderWidth: 1},
//     { data: [2,5,3,7,4, 9,2,5,3,7], label: 'HMS',  pointRadius: 1, pointBorderColor: "black", pointBorderWidth: 2, 
//     pointBackgroundColor:"yellow", fill: false, borderColor: 'black', backgroundColor: "green", borderWidth: 1},
//     { data: [6,9,7,11,8, 14,6,9,7,11], label: 'HFS',  pointRadius: 1, pointBorderColor: "black", pointBorderWidth: 2, 
//     pointBackgroundColor:"yellow", fill: false, borderColor: 'black', backgroundColor: "green", borderWidth: 1},
//     { data: [5,10,3,6,10, 13,5,8,6,10], label: 'HHS',  pointRadius: 1, pointBorderColor: "black", pointBorderWidth: 2, 
//     pointBackgroundColor:"yellow", fill: false, borderColor: 'black', backgroundColor: "green", borderWidth: 1}
//   ];

  // public lineChartLegend = true;
  // public lineChartType = 'line';
  // public lineChartPlugins = [];

  public lineChartData: ChartDataSets[] = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
  ];
  public lineChartLabels: Label[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
  public lineChartOptions = {
    responsive: true,
  };
  public lineChartColors: Color[] = [
    {
      borderColor: 'black',
      backgroundColor: 'rgba(255,0,0,0.3)',
    },
  ];
  public lineChartLegend = true;
  public lineChartType = 'line';
  public lineChartPlugins = [];


  constructor() { }

  ngOnInit(): void {
    
  }

}
